import logger from './utils/Logger';

// aws-exports.js
// Configuration for AWS Amplify to connect to AppSync GraphQL APIs

const environments = {
  dev: {
    aws_project_region: "us-east-1",
    aws_appsync_graphqlEndpoint: "https://mqr56pdhifgmpgij2y7f5wypji.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "API_KEY",
    aws_appsync_apiKey: process.env.REACT_APP_DEV_APPSYNC_API_KEY || "placeholder-dev-api-key"
  },
  live: {
    aws_project_region: "us-east-1",
    aws_appsync_graphqlEndpoint: "https://cny4booe3ncwpplns2rrmimj6m.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "API_KEY",
    aws_appsync_apiKey: process.env.REACT_APP_LIVE_APPSYNC_API_KEY || "placeholder-live-api-key"
  }
};

// Automatically determine the environment based on hostname or URL parameters
const getEnvironment = () => {
  // Production environment check - captainschess.com should ALWAYS use live
  // No exceptions, no URL parameters can override this
  if (typeof window !== 'undefined' && window.location.hostname === 'captainschess.com') {
    return 'live';
  }
  
  // Live S3 bucket should use the live environment
  if (typeof window !== 'undefined' && 
      (window.location.hostname === 'steve-chess-live.s3-website-us-east-1.amazonaws.com' ||
       window.location.hostname.includes('steve-chess-live'))) {
    return 'live';
  }
  
  // For non-production domains (local and DEV S3):
  
  // Check URL parameters for environment override
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const envParam = urlParams.get('env');
    if (envParam === 'live' || envParam === 'dev') {
      return envParam;
    }
  }
  
  // Default to dev environment
  return 'dev';
};

// Get the configuration for the current environment
const currentEnv = getEnvironment();
const config = environments[currentEnv];
logger.debug(`Using ${currentEnv} environment for API configuration`);

export default config;